import { Department, DepartmentControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author rajkumar rathod
 */
export const useAddDepartMent = () =>
  useMutationWithLoading(async (params: Department & { xTENANTID?: string }) =>
    new DepartmentControllerApi(getConfigObject()).createDepartment1(
      params,
      params.xTENANTID
    )
  );
